<template>
    <div>
        <van-nav-bar title="我的账号">
            <template #right>
                <span style="font-size:14px;color:#1989fa;" @click="signOut">退出登录</span>
            </template>
        </van-nav-bar>

        <van-pull-refresh success-text="刷新成功" v-model="refreshing" @refresh="onRefresh">
            <div style="min-height: 600px;">
                <van-list
                    :loading="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                    <div v-for="item in list" :key="item.Id" class="card">
                        <!-- 头部：点击进入详情 -->
                        <div class="card-header" @click="toDetail(item.Id)">
                            <span class="batch-name">{{ item.BatchName }}</span>
                            <van-tag :type="item.IsPay ? 'success' : 'warning'" size="medium">
                                {{ item.IsPay ? '已付款' : '未结账' }}
                            </van-tag>
                        </div>

                        <!-- 统计区：点击进入详情 -->
                        <div class="card-body" @click="toDetail(item.Id)">
                            <div class="stat-row">
                                <div class="stat-item">
                                    <span class="stat-label">总数</span>
                                    <span class="stat-value">{{ item.TotalCount }}</span>
                                </div>
                                <div class="stat-divider"></div>
                                <div class="stat-item">
                                    <span class="stat-label">已提交</span>
                                    <span class="stat-value success">{{ item.OkCount }}</span>
                                </div>
                                <div class="stat-divider"></div>
                                <div class="stat-item">
                                    <span class="stat-label">未提交</span>
                                    <span class="stat-value warning">{{ item.TotalCount - item.OkCount }}</span>
                                </div>
                            </div>

                            <van-progress
                                :percentage="item.TotalCount > 0 ? Math.round(item.OkCount / item.TotalCount * 100) : 0"
                                :color="item.OkCount === item.TotalCount ? '#07c160' : '#1989fa'"
                                style="margin-top: 12px;"
                            />
                        </div>

                        <!-- 底部：分配时间 + 下载按钮 -->
                        <div class="card-footer">
                            <div class="footer-time">
                                <span class="create-time">分配时间</span>
                                <span class="create-time">{{ item.CreateTime }}</span>
                            </div>
                            <van-button
                                size="mini"
                                type="primary"
                                plain
                                :loading="item._downloading"
                                loading-text="下载中"
                                @click.stop="downloadBatch(item)"
                            >
                                下载
                            </van-button>
                        </div>
                    </div>

                    <van-empty v-if="list.length === 0 && !loading" description="暂无批次数据" />
                </van-list>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from 'vant';
import { getBatchReq, downloadBatchReq } from '@/request.js';

export default {
    setup() {
        const router = useRouter();
        const toDetail = (id) => router.push({ path: '/detail', query: { batchId: id } });
        const signOut = () => {
            localStorage.removeItem('token');
            router.push({ path: '/login' });
        };
        const list = ref([]);
        const loading = ref(false);
        const finished = ref(false);
        const refreshing = ref(true);
        let pageIndex = 1;
        const pageSize = 10;

        const onLoad = () => {
            loading.value = true;
            getBatchReq({ pIndex: pageIndex, pSize: pageSize }, (res) => {
                if (refreshing.value) {
                    list.value = [];
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.IsSuccess) {
                    res.Result.forEach(item => list.value.push({ ...item, _downloading: false }));
                    pageIndex++;
                    if (list.value.length >= res.TotalCount) {
                        finished.value = true;
                    }
                } else {
                    finished.value = true;
                }
            }).catch(err => {
                console.error('请求失败:', err);
                loading.value = false;
                finished.value = true;
            });
        };

        const onRefresh = () => {
            pageIndex = 1;
            refreshing.value = true;
            finished.value = false;
            onLoad();
        };

        const downloadBatch = (item) => {
            item._downloading = true;
            downloadBatchReq({ batchId: item.Id }, (res) => {
                item._downloading = false;
                if (!res.IsSuccess || !res.Result) {
                    Toast('暂无数据');
                    return;
                }
                const blob = new Blob([res.Result], { type: 'text/plain;charset=utf-8' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${item.BatchName}.txt`;
                a.click();
                URL.revokeObjectURL(url);
            });
        };

        return { list, loading, finished, refreshing, onLoad, onRefresh, toDetail, signOut, downloadBatch };
    }
}
</script>

<style scoped>
.card {
    margin: 10px 12px;
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.batch-name {
    font-size: 15px;
    font-weight: bold;
    color: #333;
}

.card-body {
    background: #f8f8f8;
    border-radius: 8px;
    padding: 12px;
}

.stat-row {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.stat-label {
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
}

.stat-value {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.stat-value.success { color: #07c160; }
.stat-value.warning { color: #ff976a; }

.stat-divider {
    width: 1px;
    height: 30px;
    background: #e8e8e8;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}

.footer-time {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.create-time {
    font-size: 12px;
    color: #999;
}
</style>
